import React, { useContext, useEffect, useState } from "react";
import DashboardSideBar from "../component/DashboardSideBar";
import { useLocation, useNavigate } from "react-router-dom";
import { userContext } from "../context/UserContext";
import { Steps, Timeline } from "antd";
import {
  CheckCircleOutlined,
  GiftOutlined,
  CarOutlined,
  SmileOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { api_url, backend_domain } from "../helpers";
import ReactHtmlParser from "react-html-parser";

const OrderDetails = () => {
  const navigate = useNavigate();
  const { setUser, user, cartUpdate, setLoad } = useContext(userContext);
  const [productDetail, setProductDetail] = useState([]);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const id = useQuery().get("id");

  async function CartDataFetch() {
    setLoad(true);

    const response = await fetch(
      api_url + `resource/Sales Order/${id}`,

      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    if (response.ok == true) {
      const data = await response.json();
      console.log(data);

      if (data?.data) {
        setProductDetail(data?.data);
      }
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  useEffect(() => {
    CartDataFetch();
  }, []);

  async function OrderAgain() {
    if (productDetail?.items?.length > 0){
      for (let i=0;i<productDetail?.items?.length;i++){
        let current_item = productDetail?.items[i]
        cartUpdate({
          item_code: current_item?.item_code,
          qty: current_item?.qty,
          rate: current_item?.rate,
        })
      }
    }
  }

  return (
    <section>
      <div className="container UserDetails-custom">
        <div className="row">
          <DashboardSideBar
            currentPage="My Profile"
            navigate={navigate}
            setUser={setUser}
          />

          <div className="col-lg-9 mt-24">
            <div className="d-flex justify-content-end mb-5">
            <button onClick={() => OrderAgain()} className="btn btn-success">Order Again</button>
            </div>
            <div className="Order-Details-right-side p-0">
              <div className="Order-Details-banner d-md-flex justify-content-between">
                <div className="my-8">
                  <h6 className="mb-3 p-0 fw-normal fs-4">
                    {productDetail?.name}
                  </h6>
                  <p className="text-15">
                    {" "}
                    {productDetail?.total_qty} Products &nbsp; . &nbsp; Order
                    Placed 0n {productDetail?.transaction_date}
                  </p>
                </div>
                <div className="d-flex align-items-center">
                  <h6 className="fs-3 Order-Details-banner-h6-amount pt-sm-3 pt-md-0 mb-0">
                    {productDetail?.total} KD
                  </h6>
                </div>
              </div>

              {/* <div className="Order-Tracking-Chain">
                <p className="mt-24">
                  Order expected arrival <b>{productDetail?.delivery_date}</b>
                </p>
                
                <div className="tracking-container py-24">

                  <Steps current={3} className="order-steps pe-90 ps-90">
                    <Steps.Step
                      title=""
                      icon={<CheckCircleOutlined />}
                      description={
                        <div style={{ marginTop: 30, marginLeft: "-36px" }}>
                          <img
                            src="assets/images/icon/book (1).png"
                            className=""
                          />
                          <p className="mt-12 mb-1 text-15 text-dark">
                            Order Placed
                          </p>
                        </div>
                      }
                    />
                    <Steps.Step
                      title=""
                      icon={<ClockCircleOutlined />}
                      description={
                        <div style={{ marginTop: 30, marginLeft: "-36px" }}>
                          <img src="assets/images/icon/package.png" />
                          <p className="mt-12 mb-1 text-15 text-dark">
                            Packaging
                          </p>
                        </div>
                      }
                    />
                    <Steps.Step
                      title=""
                      icon={<CarOutlined />}
                      description={
                        <div style={{ marginTop: 30, marginLeft: "-36px" }}>
                          <img src="assets/images/icon/delivery-truck.png" />
                          <p className="mt-12 mb-1 text-15 text-dark">
                            On The Road
                          </p>
                        </div>
                      }
                    />
                    <Steps.Step
                      title=""
                      icon={<SmileOutlined />}
                      description={
                        <div style={{ marginTop: 30, marginLeft: "-36px" }}>
                          <img src="assets/images/icon/hand-shake.png" />
                          <p className="mt-12 mb-1 text-15 text-dark">
                            Delievered
                          </p>
                        </div>
                      }
                    />
                  </Steps>
                </div>
                <hr />


                <div className="order-activity py-30">
                  <h6>Order Activity</h6>

                  <Steps
                    direction="vertical"
                    current={3}
                    className="order-steps"
                  >
                    <Steps.Step
                      title="Order Confirmed"
                      icon={<CheckCircleOutlined />}
                      description="Mon, 10th Feb 2025"
                    />

                    <Steps.Step
                      title="Shipped"
                      icon={<ClockCircleOutlined />}
                      description="Tue, 11th Feb 2025"
                    />

                    <Steps.Step
                      title="Our For Delievery"
                      icon={<CarOutlined />}
                      description="Wed, 12th Feb 2025"
                    />
                    <Steps.Step
                      title="Delievered"
                      icon={<SmileOutlined />}
                      description="Wed, 12th Feb 2025"
                    />
                  </Steps>
                </div>
              </div> */}

              <hr className="w-100" />
              <div className="px-24">
                <h6 className="fs-5 pt-10 fw-normal"></h6>
              </div>
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal w-100">
                <table className="w-100 orderDetails-table">
                  <thead className="OrderDetails-right-my-order-table-thead w-100">
                    <tr>
                      <th className="px-24 py-12 text-lg">
                        {productDetail?.total_qty > 1 ? "PRODUCTS" : "PRODUCT"}{" "}
                        {`( ${productDetail?.items?.length} )`}
                      </th>
                      <th className="px-24 py-12 text-center text-lg">PRICE</th>
                      <th className="px-24 py-12 text-center text-lg">{`QUANTITY ( ${productDetail?.total_qty} )`}</th>
                      <th className="px-24 py-12 text-center text-lg">
                        SUB-TOTAL
                      </th>
                    </tr>
                  </thead>
                  {productDetail?.items?.length > 0 &&
                    productDetail?.items?.map((item, index) => {
                      return (
                        <tbody
                          className="OrderDetails-right-my-order-table-tbody"
                          key={index}
                        >
                          <tr>
                            <td className="d-flex gap-30">
                              <div className="OD_img">
                                <a
                                  href={`/singleProduct?id=${item?.item_code}`}
                                >
                                  <img
                                    src={`${backend_domain}${item?.image}`}
                                    alt=""
                                  />
                                </a>
                              </div>
                              <div className="OD-name nav-menu__item">
                                <a
                                  href={`/singleProduct?id=${item?.item_code}`}
                                  className="nav-menu__link"
                                >
                                  <p>{item?.item_name}</p>
                                </a>
                              </div>
                            </td>

                            <td className="text-center">{item?.rate} KD</td>
                            <td className="text-center">x{item?.qty}</td>
                            <td className="text-center">
                              {item?.rate * item?.qty} KD
                            </td>
                          </tr>
                        </tbody>
                      );
                    })}
                </table>
              </div>
            </div>

            <div className="Order-Details-right-side mt-16 py-30">
              <div className="">
                <h6 className="mb-3 p-0 fs-5">Shipping Address</h6>
              </div>
              <p className="mt-30 mb-1 text-18">
                <b className="text-dark">{productDetail?.customer_name}</b>
              </p>
              <p className="p-0 mb-7">
                <b>Shipping Address: </b> &nbsp; <br />
                {ReactHtmlParser(productDetail?.shipping_address)}
              </p>
              <p className="p-0 mb-7">
                <b>Delievery Date: </b> &nbsp; {productDetail?.delivery_date}
              </p>
              <p>
                <b>Email:</b> &nbsp; {productDetail?.owner}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderDetails;
